import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment";
import "moment/locale/id";

Vue.use(VueMoment, {
  moment
});
